import { render, staticRenderFns } from "./DokterProfile.vue?vue&type=template&id=04dd602e&scoped=true&"
import script from "./DokterProfile.vue?vue&type=script&lang=js&"
export * from "./DokterProfile.vue?vue&type=script&lang=js&"
import style0 from "./DokterProfile.vue?vue&type=style&index=0&id=04dd602e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dd602e",
  null
  
)

export default component.exports